const Video = {
  init(target) {
    const button = target.querySelector('.video__button')
    const iframe = target.querySelector('.video__iframe')

    if (button) {
      button.addEventListener('click', () => this.onPlay(iframe, target))
    }
  },
  onPlay(iframe, target) {
    const videoSrc = iframe.getAttribute('data-src')
    iframe.src = videoSrc
    target.classList.add('video--play')
  },
}

export default Video
